let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7oe66")).then(() => parcelRequire('3Uagz'));